<template>
    <div class="job-fitting card pt-xs pb-xs pr-sm">
        {{ `${fitting.title} | ${fitting.amount} ${unit}` }}
    </div>
</template>

<script>
export default {
    props: {
        fitting: {
            type: Object,
            required: true
        }
    },
    computed: {
        unit() {
            return this.fitting.unit ? this.fitting.unit : this.__('jobs.components.fittings.list.common.fitting_unit_default');
        }
    }
}
</script>